export default "__VITE_ASSET__DqF1UKHe__"